import get from 'lodash/get';

export default function getPropertyVirtualTourUrl(property) {
  const unbrandedVirtualTour = get(
    property,
    'listing.marketing.virtual_tour_url_unbranded',
  );

  return get(
    property,
    'listing.marketing.virtual_tour_url_branded',
    unbrandedVirtualTour,
  ) || unbrandedVirtualTour || null;
}
